<template>
  <div class="live_lesson_page">
    <div class="handle_link">
      <a href="https://v.qq.com/" target="_blank">{{$t('examResume.jump')}}</a>
      <button @click="goto_lesson">{{$t('common.returnButton')}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'liveLesson',
    data() {
      return {

      }
    },

    mounted() {
      //获取设备屏幕的高度
      const h = document.body.clientHeight - 100
      this.$refs.middle_page.style.minHeight = h + "px";
      this.$autoLogin().then(() => {
        //接收参数
        this.courseId = this.$route.query.courseId;
        this.courseName = this.$route.query.courseName;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");
        //获取考试历史信息
        this.$api.post("/studyCourseQuestion/getPastExamInfo", {
          "courseId": this.courseId
        }).then(
          (response) => {
            this.restCount = response.data.restCount;
            this.maxScore = response.data.maxScore == null ? "--" : response.data.maxScore;
            this.recentScore = response.data.recentScore == null ? "--" : response.data.recentScore;
          }
        )

      }, () => {
      })

     },
    methods: {
      goto_lesson: function() {
        let outlineInfo = {
          "courseId": this.$route.query.courseId,
          "courseName": this.$route.query.courseName
        };
        this.$router.push({
          path: "/home/curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo)
          }
        })
      },
    }
  }
</script>

<style scoped="scoped">

  .live_lesson_page {
    width: 100%;
    min-width: 1200px;
    min-height: 800px;
    background-color: rgb(100, 101, 112);
    background: url(../../../static/images/bg/personset_bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    position: relative;
  }
  .live_lesson_page .handle_link{
    width: 600px;
    height: 400px;
    background-color: rgba(0,0,0,0.3);
    border-radius: 20px;
    margin: 200px auto;
    text-align: center;
  }
  .live_lesson_page .handle_link a{
    display: inline-block;
    margin-top: 100px;
    width: 200px;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    cursor: pointer;
    padding: 4px 12px 5px 12px;
    background-color: transparent;
    border: solid #fff 1px;
    color: #fff;
    text-align: center;
    border-radius: 50px;
    transition: 0.5s ease;
  }
  .live_lesson_page .handle_link a:hover{

    color: #414141;
    background-color: #fff;
    transition: 0.5s ease;
    cursor: pointer;
  }
  .live_lesson_page .handle_link button{
    display: block;
    margin: 100px auto;
    width:75px;
    line-height: 20px;
    padding: 4px 12px 5px 12px;
    background-color: transparent;
    border: solid #fff 1px;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 20px;
    transition: 0.5s ease;

  }
  .live_lesson_page .handle_link button:hover{
    color: #414141;
    background-color: #fff;
    transition: 0.5s ease;
    cursor: pointer;

  }
</style>



// WEBPACK FOOTER //
// src/views/exam/liveLesson.vue